// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_ContentsPremiumBikeTheftNeodigitalDe = z.object({
  born_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(z.coerce.date())
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    }),
  zip_code: z
    .string()
    .min(1)
    .regex(/^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/),
  flatmates: z
    .array(z.object({ last_name: z.string().min(1), first_name: z.string().min(1) }))
    .max(5)
    .optional(),
  deductible_amount: z.coerce
    .string()
    .pipe(z.enum(['0', '250', '500']))
    .pipe(z.coerce.number()),
  number_of_previous_claims: z.coerce
    .string()
    .pipe(z.enum(['0', '1', '2']))
    .pipe(z.coerce.number()),
  bike_theft_insured_sum_amount: z.preprocess((val) => {
    if (val === '' || val === undefined) {
      return undefined
    }
    return Number(val)
  }, z.number().int().gte(0).lte(7500)),
})

const Schema_ContentsPremiumBikeTheftNeodigitalDe = BaseSchema_ContentsPremiumBikeTheftNeodigitalDe

export default Schema_ContentsPremiumBikeTheftNeodigitalDe
